export class ListSubnetsResponseV2 {
    'subnets';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "subnets",
            "baseName": "subnets",
            "type": "Array<ListSubnetsResponseV2SubnetsInner>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSubnetsResponseV2.attributeTypeMap;
    }
    constructor() {
    }
}
